export default __webpack_public_path__ + "static/media/disable-micro.a88df4f0.svg";